import React, { useState, useRef } from 'react'
import PlayersTable from './players-table'

export default function GameDetails(props) {
  const { game, playerReservations } = props
  const gameCost = parseFloat(game.facility_cost)
  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency.toUpperCase()})`

  const gameName = () => {
    return <blockquote className='blockquote' onClick={props.onEdit}>
      { game.today && 
        [
          <p key='0'>Plei Reservation</p>,
          <footer key='1'>
            {game.time_period}&nbsp;
            <span className='fa fa-pencil'></span>
          </footer>
        ]
      }
      { !game.today && 
        [
          <p key='0'>Plei Reservation</p>,
          <footer key='1'>
            {game.full_time}&nbsp;
            <span className='fa fa-pencil'></span>
          </footer>,
          <footer key='2'>
            {game.numbered_field_name}&nbsp;
            { game.numbered_field_name != game.field_name &&
              <span className='field-title-subname'>{game.field_name}</span>
            }
          </footer>
        ]
      }
    </blockquote>
  }

  return <div id='game-details'>
    <div className='row'>
      <div className='col-md-9'>
        <a className='edit-reservation-link clickable'>{gameName()}</a>
      </div>

      <div className='col-md-3'>
        <div className='panel panel-info'>
          <div className='panel-heading'>{`Total Price${currencyName}:`}</div>
          <div className='panel-body cost-edit-form-wrapper'>
            <span className='total-reservation-cost'>$ {gameCost.toFixed(2)}</span>&nbsp;
          </div>
        </div>
      </div>
    </div>

    <div className='row'>
      <div className='col-xs-12 player-reservations-table'>
        <div className='open-game-players-count'>
          {`${game.number_of_players}/${game.max_number_of_players}`}
        </div>
          <PlayersTable 
            game={game}
            playerReservations={playerReservations}
            onEditCost={props.onEditPlayerCost}
            onPayment={props.onPayment}
          />
      </div>
    </div>
    <div className='add-player-container'>
      <a className='clickable' onClick={props.onAddPlayer}>
        <i className='fa fa-plus'></i>&nbsp;Add a player
      </a>
    </div>
  </div>
}
